'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

// Reforça o scroll ao topo nesses instantes (ms) para vencer reflows tardios
// (streaming de Suspense, banners, iframes, ads, widget de acessibilidade).
const RETRY_EARLY_MS = 80
const RETRY_MID_MS = 200
const RETRY_LATE_MS = 400
const SCROLL_RETRY_DELAYS_MS = [
  RETRY_EARLY_MS,
  RETRY_MID_MS,
  RETRY_LATE_MS,
] as const

/**
 * Garante que a página sempre abra no topo (sala do curso, vitrine do curso).
 *
 * A página é `force-dynamic` e streama conteúdo via Suspense; a restauração de
 * scroll do App Router, somada a reflows tardios, pode deixar o usuário
 * posicionado no meio/rodapé ao entrar. Forçamos o topo no mount (e a cada
 * troca de sala) sem impedir o scroll manual depois.
 */
export function ScrollToTopOnEntry() {
  const pathname = usePathname()

  useEffect(() => {
    if (!pathname) {
      return
    }

    const toTop = () => window.scrollTo(0, 0)

    toTop()
    const raf = requestAnimationFrame(toTop)
    const timeouts = SCROLL_RETRY_DELAYS_MS.map(delay =>
      setTimeout(toTop, delay)
    )

    return () => {
      cancelAnimationFrame(raf)
      for (const t of timeouts) {
        clearTimeout(t)
      }
    }
  }, [pathname])

  return null
}
